import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchCommissionsLedger = createAsyncThunk(
  "commissions/fetchCommissionsLedger",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { token, userId } = getState().auth;

      if (!token) return rejectWithValue("Please login first.");
      if (!userId) return rejectWithValue("UserId not found in token.");

      const params = new URLSearchParams();
      params.set("userId", userId); // remove this line if you want all ledgers

      const url =
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/Ledger/GetCommissionsLedger" +
        `?${params.toString()}`;

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: token, // if backend expects Bearer: `Bearer ${token}`
        },
      });

      // safer parse (handles empty/invalid json)
      const raw = await res.text();
      let data = {};
      try {
        data = raw ? JSON.parse(raw) : {};
      } catch {
        data = {};
      }

      if (!res.ok) {
        const msg =
          data?.message || data?.error || `Request failed (${res.status})`;
        return rejectWithValue(msg);
      }

      // normalize list
      const d = data?.data ?? data;

      const listCandidate =
        d?.ledger ??
        d?.ledgers ??
        d?.commissionsLedger ??
        d?.commissions ??
        d?.items ??
        d?.records ??
        d?.result ??
        d?.data ??
        (Array.isArray(d) ? d : []);

      const items = Array.isArray(listCandidate) ? listCandidate : [];

      return { items };
    } catch (err) {
      return rejectWithValue(
        err?.message || "Failed to fetch commissions ledger"
      );
    }
  }
);

const commissionsSlice = createSlice({
  name: "commissions",
  initialState: {
    items: [],
    status: "idle",
    error: "",
  },
  reducers: {
    clearCommissionsError: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCommissionsLedger.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchCommissionsLedger.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload?.items || [];
      })
      .addCase(fetchCommissionsLedger.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch commissions ledger";
        state.items = [];
      });
  },
});

export const { clearCommissionsError } = commissionsSlice.actions;
export default commissionsSlice.reducer;

// selectors
export const selectCommissionsItems = (s) => s.commissions.items;
export const selectCommissionsStatus = (s) => s.commissions.status;
export const selectCommissionsError = (s) => s.commissions.error;
